import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

declare const isEmpty: any;

@Injectable()
export class Globals {
    translationPT: any;
    translationEN: any;

    constructor(private http: HttpClient, private translateBase: TranslateService) {
        this.translationPT = require("../../assets/i18n/pt-BR.json");
        this.translationEN = require("../../assets/i18n/en-US.json");
    }

    public translate(texto: string, parameters?: any): string {
        if (isEmpty(texto))
            return '';

        var parts = texto.split('.');
        var result =  this.translateBase.currentLang == 'en-US' ? this.translationEN[parts[0]] : this.translationPT[parts[0]];

        for (let i = 1; i <= parts.length - 1; i++) {
            if (isEmpty(result))
                break;

            result = this.getValue(result, parts[i]);
        }

        if (parameters) {
            for (const key in parameters) {
                if (parameters.hasOwnProperty(key)) {
                    result = result.replace(`{{${key}}}`, parameters[key]);
                }
            }
        }

        return result;
    }

    private getValue(obj, name) {
        return obj[name];
    }
}
